import { render, staticRenderFns } from "./index.vue?vue&type=template&id=756caf1e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=756caf1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756caf1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('756caf1e')) {
      api.createRecord('756caf1e', component.options)
    } else {
      api.reload('756caf1e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=756caf1e&scoped=true&", function () {
      api.rerender('756caf1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/index.vue"
export default component.exports